(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
svs.numbergames.mybets_common_wager.models.Wager = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    wagerId: undefined,
    productName: '',
    productId: '',
    betAmount: undefined,
    channel: '',
    bagType: 0,
    packageName: undefined,
    description: '',
    extraDescription: undefined,
    descriptionItems: undefined,
    isSystemWager: false,
    isPackageWager: false,
    isCompositePackage: false,
    isSingleWager: false,
    isUserBoards: false,
    isSubscription: false,
    isFraction: false,
    fractionHolderFractionCount: 0,
    fractionHolderAmount: undefined,
    customerFractionCount: 0,
    isSyndicate: false,
    syndicateId: undefined,
    syndicateName: undefined,
    syndicateBettor: undefined,
    syndicateParticipantCount: undefined,
    syndicateParticipatingMembers: undefined,
    syndicateMembers: undefined,
    syndicateCurrentMember: undefined,
    syndicateIsPermissionBlocked: false,
    isCancellable: true,
    currentDrawNumber: '',
    currentAddonDrawNumber: undefined,
    currentDrawCount: 1,
    isCancelClosed: false,
    isPreProlonged: false,
    cancelCloseTime: '',
    isRegClosed: false,
    regCloseTime: '',
    isProlonged: false,
    firstDrawNumber: undefined,
    completedDrawCount: 0,
    totalDrawCount: 1,
    hasMultipleDraws: false,
    regWagerTime: '',
    lastDrawDate: '',
    isExamined: false,
    winAmount: 0,
    completedOn: '',
    bet: undefined,
    jokerBet: undefined,
    rowCount: 0,
    hasLotto2: false,
    hasJoker: false,
    lotto1Bet: undefined,
    lotto2Bet: undefined,
    originalNumDraws: undefined,
    originalApiWager: undefined
  },
  fetchAction(options) {
    drawgamesApiCaller.getPlayerWagerById({
      wagerId: this.get('wagerId')
    }).then(_ref => {
      let response = _ref.response;
      return options.success(response);
    }).catch(error => options.error(error));
  },
  parseRawResponse(resp) {
    return resp.wager;
  },
  initialize() {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager initialize', this.attributes);
  },
  parse(attrs, options) {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager parse', attrs);
    const originalApiWager = attrs;
    if (options !== null && options !== void 0 && options.parseFinishedWager) {
      var _svs$numbergames$mybe = svs.numbergames.mybets_core_wager.parsers.parseFinishedWagers([attrs], options.context.syndicates);
      var _svs$numbergames$mybe2 = _slicedToArray(_svs$numbergames$mybe, 1);
      attrs = _svs$numbergames$mybe2[0];
    } else {
      attrs = svs.numbergames.mybets_core_wager.parsers.parseWager(attrs);
    }
    if (attrs.bet) {
      attrs.bet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.bet, {
        parse: true
      });
    }
    if (attrs.jokerBet) {
      attrs.jokerBet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.jokerBet, {
        parse: true
      });
    }
    return _objectSpread(_objectSpread({}, attrs), {}, {
      originalApiWager
    });
  }
});

 })(window);